import type { TFunc } from '@/utils/tfunc';
/**
 * Tenant names are DATA and must render exactly as stored — translating a
 * customer's organisation name would be wrong.
 *
 * The one exception is the synthetic root the backend wraps a super-admin's
 * forest in when the platform has more than one root tenant
 * (group_admin/api/routes.py). It is not a real tenant: it has the reserved id
 * `__all_tenants__` and an English display name, and it was the last piece of
 * chrome on the admin page still reading "All Tenants" in Hebrew.
 *
 * Keyed off the reserved id rather than the name, so it stays correct if the
 * backend's English ever changes.
 */
const SYNTHETIC_ALL_TENANTS_ID = '__all_tenants__';


export function tenantDisplayName(
  t: TFunc,
  tenant: { tenant_id?: string | null; tenant_name?: string | null } | null | undefined,
): string {
  if (!tenant) return '';
  if (tenant.tenant_id === SYNTHETIC_ALL_TENANTS_ID) return t('admin.allTenantsNode');
  return tenant.tenant_name ?? '';
}
